import pageModal from './src/pageModal.vue'

export default pageModal
